const s = require("./config.module.scss");
import { default as React } from "react";
import { withTranslation } from "react-i18next";

interface OwnProps {
    values: string[];
    selected: string;
    onChange: (s: string) => void;
}

const SelectField = ({ selected, values, onChange }: OwnProps) => (
    <select className={s.selectField} onChange={e => onChange(e.target.value)} value={selected}>
        {values.concat("").map(x => <option value={x} key={x}>{x}</option>)}
    </select>
);

export default withTranslation()(SelectField);